import { render } from "./home_one_column.vue?vue&type=template&id=5fdfb4fa"
import script from "./home_one_column.vue?vue&type=script&lang=js"
export * from "./home_one_column.vue?vue&type=script&lang=js"

import "./home_one_column.vue?vue&type=style&index=0&id=5fdfb4fa&lang=scss"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__